import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import AppointmentModalStore from './store';
import PhoneCodeInput from '../phone-code-input';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const AppointmentModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.modalWrap)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        {store.type === 1 && (
          <div>
            <div className={styles.phoneWrap}>
              <PhoneCodeInput store={store.phoneCodeInputStore} />
            </div>
            <div className={styles.agree} onClick={() => store.checkAgree()}>
              <span className={store.agree ? styles.checked : ''} />
              已阅读并同意
              <Link
                className={styles.agreeLink}
                target="_blank"
                href="https://js4.seasungames.cn/p/zt/2025/07/21/privacy/index.html?contentId=snazprh7aww1"
                onClick={e => e.stopPropagation()}
              >
                《金山网络服务使用协议》
              </Link>、
              <Link
                className={styles.agreeLink}
                target="_blank"
                href="https://js4.seasungames.cn/p/zt/2025/07/21/privacy/index.html?contentId=snazvjmyopa9"
                onClick={e => e.stopPropagation()}
              >
                《金山在线隐私权政策》
              </Link>
            </div>
            <div className={styles.channel}>
              {store.channel.map((item, index) => {
                return (
                  <Link
                    className={cx(styles.channelItem, { [styles.active]: store.currentChannel.includes(item.code) })}
                    key={item.id}
                    onClick={() => store.selectChannel(item.code)}
                  >
                    {item.name}
                  </Link>
                );
              })}
            </div>
            <div className={styles.tips}>*选择您的设备，点击“预约”代表您同意我们向您的 手机号发送短信通知或以手机号参与活动</div>
            <Link className={styles.submit} onClick={() => store.submit()} />
            <Link className={styles.changeSend} data-name="扫码预约" onClick={() => store.changeType(2)} />
          </div>
        )}
        {store.type === 2 && (
          <div>
            <div className={styles.sendTitle} />
            <div className={styles.sendBox}>
              {store.qrcodeImg ? <img src={store.qrcodeImg} alt="扫码预约" /> : <div className={styles.loadingImg}>加载中...</div>}
            </div>
            <Link className={cx(styles.changeSend, styles.changePhone)} data-name="扫码预约" onClick={() => store.changeType(1)} />
          </div>
        )}
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentModal, AppointmentModalStore);
